import { AdditionalInsuredModel } from '../user-models/AdditionalInsuredModel'

export class COI {
    certificateId: String
    certificateUrl: String
    certificateInformation: COIInformation
    insuranceId: String
    isActive: Boolean
    dateAdded: Date
    lastUpdated: Date
    version: Number
}

export class COIInformation {
    namedInsured: String
    namedInsuredAddress: String
    validFrom: Date
    validUntil: Date
    issuedTime: Date
    policyNumber: String
    liabilityLimit: String
    timezoneAbbreviation: String
    insuranceId: String
    insuranceDescription: String
    additionalInsured: AdditionalInsuredModel[]
    effectiveTimePeriods: any[]
}
